import { render, staticRenderFns } from "./SprintsForm.vue?vue&type=template&id=58178dfe&scoped=true"
import script from "./SprintsForm.vue?vue&type=script&lang=js"
export * from "./SprintsForm.vue?vue&type=script&lang=js"
import style0 from "./SprintsForm.vue?vue&type=style&index=0&id=58178dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58178dfe",
  null
  
)

export default component.exports